var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch20 = function SvgSearch20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.167 3.25a5.917 5.917 0 0 1 4.255 10.027.753.753 0 0 0-.145.145A5.917 5.917 0 1 1 9.167 3.25Zm4.687 11.665a7.417 7.417 0 1 1 1.06-1.06l3.116 3.115a.75.75 0 1 1-1.06 1.06l-3.116-3.116Z",
    fill: "#526169"
  })));
};
export default SvgSearch20;